import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { openPopupWindow } from 'cityads-v3/utils/htmlUtils';

import ShareButton from './ShareButton';

import { getVkUrlInfo } from 'cityads-v3/actions/social';

@connect(
  (state, props) => ({
    shareInfo: state.social.vkInfoByUrl[props.url],
  })
)
export default class VkShareButton extends PureComponent {
  static propTypes = {
    url      : PropTypes.string,
    shareInfo: PropTypes.object,
  }

  componentDidMount() {
    const { dispatch, shareInfo, url } = this.props;

    if (!shareInfo && shareInfo !== null) {
      dispatch(getVkUrlInfo(url));
    }
  }

  componentDidUpdate(prevProps) {
    const { dispatch, shareInfo, url } = this.props;
    const { url: prevUrl } = prevProps;

    if (prevUrl !== url && !shareInfo && shareInfo !== null) {
      dispatch(getVkUrlInfo(url));
    }
  }

  render() {
    const { url, shareInfo, title, image, ...rest } = this.props;

    return (
      <ShareButton
        icon    = {require('./VkShareButton.png')}
        count   = {shareInfo ? shareInfo.shareCount : null}
        url     = {url}
        onClick = {(evt) => {
          openPopupWindow({
            url: `https://vk.com/share.php?url=${encodeURIComponent(url)}&title=${title}&image=${image}`,
            width: 655,
            height: 450,
          });
          evt.stopPropagation();
        }}
        {...rest}
      />
    );
  }
}
